const Container = ({ children: Children }) => (
  <div className='relative px-2 md:px-16 lg:px-32 xl:px-32' data-testid='container-div'>
    {Children}
  </div>
);

export default Container;
